import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";
import {
  VOID_CONFIRM_MESSAGE,
  VOID_STATUS_FIELD,
} from "../utils/voidTransactionConfig";

export const screen_141_purchase_return: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "126",
      action: "navigate_modulev1/purchase_return_add",
    },
    title: "Purchase return voucher",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "purchase_return_no",
            Name: "purchase_return_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/purchase_return_add/<id>",
                },
                ActionType: "Edit",
                hiddenWhenVoid: true,
              },
                            {
                ActionType: ActionType.VOID,
                permissionKey: "Void",
                confirmMessage: VOID_CONFIRM_MESSAGE,
                requireVoidReason: true,
                hiddenWhenVoid: true,
                visibleWhenNotDraft: true,
                voidReasonLabel: "Void Reason",
                tooltip: "Void",
                Action: {
                  Module: "pur_ret_add",
                  TransactionNoField: "purchase_return_no",
                },
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "purchase_return_summary",
                },
                ActionType: "Delete",
                hiddenWhenVoid: true,
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "purchase_return_pdf_view",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
              tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "purchase_return_summary",
              TableName: "purchase_return",
              DisplayName: "purchase_return_summary",
              Query:
                "SELECT purchase_return.id, purchase_return.purchase_retrun_date, purchase_return.purchase_return_no, P.purchase_no, purchase_return.vendor_refno, COALESCE(supplier_details.suppliername, '') AS suppliername, COALESCE(purchase_return.amount, 0) AS gross_amount, COALESCE(purchase_return.vat_amount, 0) AS vat_amount, COALESCE(purchase_return.net_amount, 0) AS net_amount, users.username AS created_by, purchase_return.is_void, CASE WHEN COALESCE(purchase_return.is_void, 0) = 1 THEN 'Void' ELSE '' END AS status FROM purchase_return LEFT JOIN purchase P ON P.id = purchase_return.purchase_id LEFT JOIN purchase_order POR ON POR.id = P.purchase_order_id LEFT JOIN supplier_details ON supplier_details.id = COALESCE(P.supplier_id, POR.supplier_id) LEFT JOIN users ON users.id = purchase_return.created_by WHERE purchase_return.soft_delete = 0 ORDER BY purchase_return.purchase_retrun_date DESC, purchase_return.purchase_return_no DESC",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "txt_id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                VOID_STATUS_FIELD,
                {
                  IncludeLabel: true,
                  Label: "Return date",
                  IsMandatory: false,
                  BindValue: "txt_returndate",
                  Json_Attribute: "purchase_retrun_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Return No.",
                  BindValue: "txt_pr_ord_no",
                  Json_Attribute: "purchase_return_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Purchase No.",
                  BindValue: "txt_prno",
                  Json_Attribute: "purchase_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Ref No.",
                  BindValue: "txt_Refno",
                  Json_Attribute: "vendor_refno",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vendor name",
                  BindValue: "name",
                  Json_Attribute: "suppliername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Gross amount",
                  BindValue: "txt_gross_amt",
                  Json_Attribute: "gross_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "VAT amount",
                  BindValue: "txt_vat_amt",
                  Json_Attribute: "vat_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Net amount",
                  BindValue: "txt_net_amt",
                  Json_Attribute: "net_amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "created_by",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];

